import React from 'react';
import _ from 'lodash';

import { Icon } from '../../components';
import { Section } from '../../styles/Global.style';
import { HeaderWrapper } from './DocumentHeader.style';

export const DocumentHeader = ({ documentHeaderData }) => {
  return (
    <>
      <Section>
        <HeaderWrapper>
          <div className="header-content">
            <div className='table'>
              {documentHeaderData &&
                Object.keys(documentHeaderData)
                  .filter((key) => documentHeaderData[key])
                  .map((key, i) => (
                    <div className='table-col' key={`${key}${i}`}>
                      <div className="header-key table-col-body">
                        <Icon title={key} />
                        {key}
                      </div>
                      <div className="table-col-body">{documentHeaderData[key]}</div>
                    </div>
                  ))}
            </div>
          </div>
        </HeaderWrapper>
      </Section>
    </>
  );
};
